export default __webpack_public_path__ + "static/media/image-schedule.406570f0.png";